import { render, staticRenderFns } from "./CProductDescription.vue?vue&type=template&id=06bc72a6&"
import script from "./CProductDescription.vue?vue&type=script&lang=js&"
export * from "./CProductDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports